export default __webpack_public_path__ + "static/media/5.996fafd5.svg";